import React from "react";
import Accordion from "react-bootstrap/Accordion";
import PaginationModified from "../../data/PaginationModified";
import { formatDateTimezon, formattedLongDate } from "../common-data/Converts";

const CuponRequestMobile = ({
  tableData,
  tablePagination,
  isPage,
  setIsPage,
  selectedTab,
  setModValues,
}) => {
  function getPagination() {
    try {
      const pagination = tablePagination ? tablePagination : [];
      return pagination;
    } catch (error) {
      console.log(error);
    }
  }

  return (
    <div className="all-leads-log mt30">
      {tableData?.length > 0 &&
        tableData.map((row, index) => {
          const isDisbaled = row?.status !== "pending";

          return (
            <div className="log-card" key={index}>
              <div className="all-info">
                <div className="log-card-top">
                  <h3 className="lead-name name-checkbox">
                    {row?.user_name || "NA"}
                  </h3>

                  <span
                    className={`lead-type ${row?.status}`}
                    style={{
                      background:
                        row?.status === "approved" ? "#E2EFD5" : "#F3DADA",
                      color: row?.status === "approved" ? "#379C00" : "#D90000",
                    }}
                  >
                    {row?.status || "NA"}
                  </span>
                </div>

                <div className="card-other-info">
                  <span className="value semi-bold">
                    {row?.user_mobile || ""}
                  </span>
                  {row?.user_email ? (
                    <span className="value email semi-bold">
                      {row?.user_email || "NA"}
                    </span>
                  ) : null}
                  <span className="value semi-bold">
                    {row?.gym_name || "NA"}
                  </span>
                </div>

                <div className="all-followuo-info-container">
                  <Accordion>
                    <Accordion.Item eventKey="0">
                      <Accordion.Header>
                        <div className="heade-info">
                          <span className="title">plan name</span>
                          <span className="value">
                            {row?.plan_name?.replace(/_/g, " ") || "NA"}
                          </span>
                        </div>
                      </Accordion.Header>

                      <Accordion.Body>
                        <div className="lead-multi-value-cols px20px pb20px">
                          <div className="label-value">
                            <span className="label">request date</span>
                            <span className="value">
                              {row?.date ? formatDateTimezon(row.date) : "-"}
                            </span>
                          </div>

                          {selectedTab !== 1 && selectedTab !== 3 && (
                            <div className="label-value">
                              <span className="label">approved coupon</span>
                              <span className="value">
                                {row?.approved_coupon || "-"}
                                <br />({row?.extendable_days || 0} Days)
                              </span>
                            </div>
                          )}

                          <div className="label-value">
                            <span className="label">agent</span>
                            <span className="value">
                              {row?.agent_name || "NA"}
                              <br />
                              <small
                                style={{
                                  textTransform: "lowercase",
                                }}
                              >
                                {row?.agent_mobile || ""}
                                <br />
                                {row?.agent_email || ""}
                              </small>
                            </span>
                          </div>

                          {selectedTab !== 1 && selectedTab !== 3 && (
                            <div className="label-value">
                              <span className="label">approved by</span>
                              <span className="value">
                                {row?.approved_by_name || "NA"}
                                <br />
                                <small
                                  style={{
                                    textTransform: "lowercase",
                                  }}
                                >
                                  {row?.approved_by_mobile || ""}
                                  <br />
                                  {row?.approved_by_email || ""}
                                </small>
                              </span>
                            </div>
                          )}

                          <div className="label-value">
                            <span className="label">date added</span>
                            <span className="value">
                              {row?.date_added
                                ? formattedLongDate(row.date_added)
                                : "-"}
                            </span>
                          </div>
                        </div>

                        {(selectedTab === 0 || selectedTab === 1) && (
                          <div className="all-btns lead-btn-axceed">
                            <div className="lead-log-box">
                              <button
                                className="lead-log view-lead"
                                onClick={() =>
                                  setModValues((prevs) => ({
                                    ...prevs,
                                    isModOpen: true,
                                    cardName: "coupon_list",
                                    rowData: row,
                                  }))
                                }
                                disabled={isDisbaled}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="16"
                                  height="16"
                                  fill="currentColor"
                                  className="bi bi-view-list"
                                  viewBox="0 0 16 16"
                                >
                                  <path d="M3 4.5h10a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2m0 1a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1zM1 2a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 0 1h-13A.5.5 0 0 1 1 2m0 12a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 0 1h-13A.5.5 0 0 1 1 14" />
                                </svg>
                              </button>

                              <span className="btn-label">approve</span>
                            </div>
                          </div>
                        )}
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                </div>
              </div>
            </div>
          );
        })}

      <div className="lead-logs-card-pagination">
        <PaginationModified
          isPage={isPage}
          onChangePage={setIsPage}
          pagination={getPagination()}
        />
      </div>
    </div>
  );
};

export default CuponRequestMobile;
